/**
 * Shared Emotion style for the wrappers around `@ryerson/frontend.media` → `Video` on hero and
 * profile sections (for example `components/History/Hero/Hero.tsx`,
 * `components/Leadership/Profile/LeadershipProfile.tsx`). Their props type is
 * `components/Helper/common.tsx` → `VideoWrapperProps`.
 */
import { css } from "@emotion/react";

/**
 * Padding on the side of a video wrapper where the play button sits.
 *
 * `orientation` is the `Video`'s `buttonOrientation`; `"top-right"` pads the top. On mobile,
 * `"left"` and `"right"` pad both sides equally. `buttonSize` `"lg"` / `"md"` / anything else
 * gives 55 / 45 / 35px on mobile and 75 / 65 / 50px on desktop. Called with `"center"` it emits
 * `padding-center`, which isn't a CSS property: callers that can receive `"center"` use 0 instead
 * of calling this; `components/Tutorials/VideoList/VideoList.tsx` never passes it.
 */
export const getVideoPadding = (orientation: string, isMobile: boolean, buttonSize: string) => {
	const paddingMobile = buttonSize === "lg" ? "55px" : buttonSize === "md" ? "45px" : "35px";
	const paddingDesktop = buttonSize === "lg" ? "75px" : buttonSize === "md" ? "65px" : "50px";
	const paddingPosition = orientation !== "top-right" ? orientation : "top";
	const paddingValue = isMobile ? paddingMobile : paddingDesktop
	if (isMobile && (paddingPosition === "left" || paddingPosition === "right")) {
		return css`
			padding-left: ${paddingValue};
			padding-right: ${paddingValue};
		`;
	} else {
		return css`
			padding-${paddingPosition}: ${paddingValue};
		`;
	}
}